// Copyright (C) CVAT.ai Corporation
//
// SPDX-License-Identifier: MIT

const dimensions = {
    xs: 24,
    sm: 24,
    md: 22,
    lg: 18,
    xl: 16,
    xxl: 16,
};

export default dimensions;
